export default {
    list(state) {
        return state.list;
    },
    account(state) {
        return state.account;
    }
}
